<template>
  <main id="main_body">
    <top-menu :top_title="top_title" ref="topMenu"></top-menu>
    <div class="div_padding"></div>
    <div class="wrapper">
      <div class="main_text_box">
        <h3>
          <span id="top_title">{{ userName }}</span
          >님. 함께 공유하고
        </h3>
        <h3>즐거움과 혜택을 <span id="thehae">더해</span>보세요.</h3>
      </div>
      <div class="fus_area">
        <div id="fus" class="fus_info">
          <div class="fus_title"><span>나날이 더해가는 FUS</span></div>
          <div class="fus"><span class="fus_big" v-html="data_big">0000</span><span class="fus_dot">.</span><span class="fus_small" v-html="data_small">00</span></div>
          <div class="fus_help" style="position: relative">
            <span>FUS</span>
            <div href="" class="help" v-if="coinDesc" @click="toggleCoin($event)">
              <div class="main_baloon">
                <p v-html="coinDesc"></p>
              </div>
            </div>
          </div>
          <div class="fus_krw">
            <span v-text="data_krw"></span>
            <span @click="updateFus"><img src="images/basic/icon/sync.svg" alt="" /></span>
          </div>
        </div>
        <div class="icon_send_div">
          <img onclick="location_sendCoin();" src="images/basic/icon/send-fus.svg" alt="" />
        </div>
      </div>
    </div>

    <!-- userInfo.userGrade -->
    <div class="main_nft" v-if="userInfo.userGrade != ''">
      <div class="nft_box">
        <div class="lt_box" onclick="location.href='/nftForm'">
          <span class="icon_box">
            <img src="/images/icon/nft.svg" alt="">
          </span>
          <span class="text">내 NFT</span>
          <span class="count">{{userInfo.nftCountView}}</span>
        </div>
        <div class="rt_box" onclick="location.href='/pointList'">
          <span class="icon">ⓟ</span>
          <span class="number">{{userInfo.nftPointView}}</span>
          <span class="arrow"><img src="images/basic/icon/arrow-right-thin.svg" alt=""></span>
        </div>
      </div>
    </div>
    <div id="main_top">
      <swiper class="swiper" :options="mainSwiperOption">
        <swiper-slide v-for="list in banner" :key="list.bnId"> <img :src="list.bnImageUrl" alt="" @click="goToDetailPage(list)" loading="lazy" /></swiper-slide>
        <div id="main_progress" class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="wrapper">
      <div class="icon_menu">
        <div class="sub_text_box">
          <h3>FUS를<span id="thehae">&nbsp;더해</span>보세요.</h3>
          <p>다양한 방법으로 더해!봐요. 참여만 해도 더 더해줘요.</p>
        </div>
        <div class="icon_set">
          <div class="icon">
            <div class="icon_community_div">
              <div class="img">
                <img onclick="location.href='/community'" src="images/basic/icon/community.svg" alt="" />
              </div>
              <p>커뮤니티</p>
            </div>
            <!--<div class="icon_toto_div">
                            <div class="img" onclick="location.href ='/mining_detail'">
                                <img src="images/basic/icon/updowngame.svg" alt="">
                            </div>
                            <p>코인+-</p>
                        </div> -->
            <div class="icon_roulette_div">
              <div class="img" onclick="location.href ='/roulette'">
                <img src="images/basic/icon/roulette.svg" alt="" />
              </div>
              <p>룰렛</p>
            </div>
          </div>
          <div class="icon">
            <div class="icon_event_div">
              <div class="img" onclick="location.href ='/event'">
                <img src="images/basic/icon/event.svg" alt="" />
              </div>
              <p>이벤트</p>
            </div>
            <!--<div class="icon_dice_div">
                            <div class="img" onclick="location.href ='/dice'">
                                <img src="images/basic/icon/dice.svg" alt="">
                            </div>
                            <p>주사위</p>
                        </div>-->
            <div class="icon_slotmachine_div">
              <div class="img" onclick="location.href='/slotmachine'">
                <img src="images/basic/icon/slotmachine.svg" alt="" />
              </div>
              <p>슬롯머신</p>
            </div>
          </div>
          <div class="icon">
            <div class="icon_invite_div">
              <div class="img" onclick="location.href ='/invite'">
                <img src="images/basic/icon/invite.svg" alt="" />
              </div>
              <p>친구초대</p>
            </div>
            <!-- <div class="icon_shopping_div">
                        <div class="img">
                            <img onclick="location.href='/shopping'" src="images/basic/icon/shopping.svg" alt="">
                        </div>
                        <p>쇼핑</p>
                        </div> -->
            <div class="icon_luckcard_div">
              <div class="img" onclick="location.href='/luckycard'">
                <img src="images/basic/icon/luckcard.svg" alt="" />
              </div>
              <p>복권</p>
            </div>
          </div>
          <div class="icon">
            <div class="icon_attention_div" @click="goToDailyAttendance">
              <div class="img">
                <img src="images/basic/icon/attention.svg" alt="" />
              </div>
              <p>출석체크</p>
            </div>
            <div class="icon_dice_div">
              <div class="img" onclick="location.href ='/dice'">
                <img src="images/basic/icon/dice.svg" alt="" />
              </div>
              <p>주사위</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner_main_long" id="slide_banner">
      <div class="banners swiper-container" id="main_sub">
        <swiper class="swiper" :options="subSwiperOption">
          <swiper-slide v-for="list in subBanner" :key="list.bnId"><img v-bind:src="list.bnImageUrl != undefined ? list.bnImageUrl : 'images/banner/sub_banner_dummy.png'" onerror="this.src='images/banner/sub_banner_dummy.png'" alt="" @click="goToDetailPage(list)" /></swiper-slide>
          <div id="sub_progress" class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="wrapper ranking">
      <div class="ul_menu_div">
        <ul class="menu_ul">
          <li v-for="menu in resultList" @click="selectBoardList(menu.boardId)" :key="menu.boardId" :class="boardId == menu.boardId ? 'active' : ''">{{ menu.boardNm }}</li>
        </ul>
      </div>
      <div id="board_list" class="list_div" v-if="boardCnt !== 0">
        <div class="list_li" v-for="(list, index) in board" :key="list.rank" @click="goToCmView(list.boardId, list.nttId)" v-show="!reportUsers.includes(list.regId)">
          <div class="num" v-html="index + 1"></div>
          <div class="content" v-text="list.nttSj"></div>
          <template v-if="list.commentAt == 'Y' & list.commentCnt > 0">
             <span class="reply">+</span><span class="reply" v-text="list.commentCnt"></span>
          </template>
        </div>
      </div>
      <div v-else>
        <div class="unlisted_wrap" @click="goToCmWrite">
          <img src="images/basic/img/writePost.png" width="107.79" height="90" />
          <p class="title">등록된 글이 없습니다.</p>
          <span class="sub_title">{{ this.$store.state.userInfo.name }}님 지금 글을 등록해보세요!</span>
        </div>
      </div>
      <div class="app_extanal">
        <img id="banner" src="images/basic/img/external_img.png" alt="" />
      </div>

      <div class="main_mining_guide">
        <div class="title">
          <h2><span id="thehae">더해</span> 채굴 가이드</h2>
          <p>FUS 코인은 채굴권을 사용하여 채굴 게임에서 획득하실 수 있어요. 채굴권은 다양한 앱내 활동으로 획득하실 수 있습니다.</p>
        </div>
        <div class="guide_list">
          <div class="num_data" v-for="(mining, idx) in miningList" :key="idx">
            <p class="cnt">+{{ mining.ticketCnt }}</p>
            <p class="name">{{ mining.ticketNm }}</p>
            <p class="text">{{ mining.tickeText }}</p>
          </div>
        </div>
        <div class="mining_desc">그 외 다양한 방법으로 채굴권을 획득하실 수 있도록 준비중입니다.</div>
        <!-- <img src="images/basic/img/shutterstock_1667792377.svg" /> -->
        <img src="images/basic/img/mining-guide.png" class="mining-guide-img" />
      </div>
    </div>
    <main-footer :noticeList="noticeList" :tel="tel" :operTime="operTime" :snsList="snsList" :termsList="termsList"></main-footer>
    <bottom-menu :switchIcon="switchIcon"></bottom-menu>
  </main>
</template>

<script>
import MainFooter from "@/components/common/MainFooter.vue";
import TopMenu from "@/components/common/TopMenu";
import BottomMenu from "@/components/common/BottomMenu";
import { fetchMainBanners, fetchSubBanners } from "@/api/banners";
import { fetchTabList, fetchNoticeList, fetchSelectBestList } from "@/api/boards";
import { fetchMainCommonInfo } from "@/api/info";
import { updateBalance } from "@/api/fus";
import { fetchEventDetail } from "@/api/event";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    MainFooter,
    TopMenu,
    BottomMenu,
    Swiper,
    SwiperSlide,
  },
  created() {
    window.VueRoot=this;
    this.boardId = this.$store.state.selectedBoardId;
    this.switchIcon = !this.switchIcon;
    this.fetchData();
    //this.selectBoardList(this.boardId);
    this.getMainCommonInfo();
  },
  mounted() {
    
  },
  data() {
    return {
      resultList: [],
      noticeList: [],
      banner: [],
      subBanner: [],
      boardId: "",
      board: [],
      top_title: '<img src="images/basic/logo/logo.svg" alt="" height="20">',
      switchIcon: false,
      boardCnt: 0,
      subSwiperOption: {
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
          loop: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
      },
      mainSwiperOption: {
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
          loop: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
      },
      coinDescription: "",
      tel: "",
      operTime: "",
      snsList: [],
      miningList: [],
      termsList: [],
    };
  },
  computed: {
    userName() {
      return this.$store.state.userInfo.name;
      //return  encodeURIComponent(this.$store.state.userInfo.name);
    },
    data_krw() {
      return `1FUS = KRW${this.$store.state.userInfo.fusKrw}`;
    },
    data_big() {
      const coin = this.$store.state.userInfo.accountCoinView;
      if (coin == undefined) return "0";
      //const temp = coin.toFixed(2);
      const bigCoin = coin.split(".");
      return bigCoin[0];
    },
    data_small() {
      var coin = this.$store.state.userInfo.accountCoinView;
      if (coin == undefined) return "00";
      if(coin.includes(".")){
        const smallCoin = coin.split(".");
        return smallCoin[1];
      }else{
        return "0";
      }
    },
    coinDesc() {
      const coinCmt = this.$store.state.userInfo.coinDesc;
      if (coinCmt == undefined) return 0;
      return coinCmt.replace(/(?:\r\n|\r|\n)/g, "</br>");
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    reportUsers(){
      var reportUsersArray = this.$store.state.report_users;
      if(reportUsersArray == undefined) return [];
      return reportUsersArray;
    }
  },
  methods: {
    async fetchData() {
      try {
        const getMainBanner = await fetchMainBanners();
        this.banner = getMainBanner.data.bannerList;

        const getSubBanner = await fetchSubBanners();
        this.subBanner = getSubBanner.data.bannerList;

        const getTabList = await fetchTabList();
        this.resultList = getTabList.data.resultList;
        if(this.boardId == "") this.boardId = this.resultList[0].boardId;
        this.selectBoardList(this.boardId);

        const getNoticeList = await fetchNoticeList({
          searchType: "main",
          recordCntOnPage: 3,
        });
        this.noticeList = getNoticeList.data.resultList;
      } catch (error) {
        console.log(error);
      }
    },
    async selectBoardList(boardId) {
      try {
        this.boardId = boardId;
        this.$store.commit("udtBoardId", boardId);
        const getBoardList = await fetchSelectBestList({
          boardId,
          recordCntOnPage: 10,
        });
        this.board = getBoardList.data.resultList;
        this.boardCnt = getBoardList.data.resultCnt;
      } catch (error) {
        console.log(error);
      }
    },
    getMainCommonInfo() {
      fetchMainCommonInfo().then(({ data }) => {
        this.tel = data.result.tel;
        this.operTime = data.result.operatingTime;
        this.snsList = data.result.snsList;
        this.miningList = data.result.miningList;
        this.termsList = data.result.termsList;
      });
    },
    goToCmView(boardId, nttId) {
      this.$router.push({
        path: "/community_view",
        query: {
          boardId,
          nttId,
        },
      });
    },
    goToCmWrite() {
      this.$router.push("/community_write");
    },
    updateFus() {
      updateBalance()
        .then(({ data }) => {
          this.$store.commit("udtFus", data.fusKrw);
          this.$store.commit("udtAccountCoin", data.accountCoin);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleCoin(e) {
      window.$(e.target).children(".main_baloon").slideToggle("fast");
      window.$(e.target).toggleClass("active");
    },
    goToDailyAttendance() {
      this.$router.push("/attendanceEvent");
    },
    goToDetailPage(list) {
      if (list.linkType == "noticeDetail") {
        this.$router.push({
          path: "/noticeDetail",
          query: { nttId: list.nttId },
        });
      }
      if (list.linkType == "boardDetail") {
        this.$router.push({
          path: "/community_view",
          query: { boardId: list.boardId, nttId: list.nttId },
        });
      }
      if (list.linkType == "eventDetail") {
        fetchEventDetail({
          nttId:list.nttId
        }).then(({ data }) => {
          var event_status = data.result.status;
          var url = "/ongoingEvent";
          switch(event_status){
            case "ING":  url = "/ongoingEvent"; break;
            case "READY":url = "/upcomingEvent"; break;
            case "END":  url = "/endedEvent"; break;
          }
          this.$router.push({
            path: url,
            query: { nttId: list.nttId },
          });
        });
      }
      if (list.linkType == "link") {
        var link = list.linkUrl;
        this.$router.push({
          path: link,
        });
      }
    },
  },
  destroyed() {
    this.switchIcon = !this.switchIcon;
  },
};
</script>

<style scoped>
.help .main_baloon {
  background-color: var(--Gray-Dark);
  border-radius: 5px;
  position: absolute;
  left: 53px;
  top: -30px;
  width: 160px;
  padding: 15px;
  display: none;
  line-height: initial;
  text-align: left;
  height: auto;
}

.help .main_baloon p {
  color: var(--Gray-Pale) !important;
  font-weight: normal !important;
  font-size: 12px !important;
  margin-bottom: 5px;
}
.unlisted_wrap {
  text-align: center;
}

.unlisted_wrap .title {
  margin-top: 5px;
  font-size: 16px;
  font-weight: 400;
}

.unlisted_wrap .sub_title {
  font-size: 13px;
  color: #6f737a;
}

#main_progress {
  width: 90%;
  height: 3px;
  bottom: 0;
  right: 0;
  top: initial;
  left: initial;
}
#sub_progress {
  height: 3px;
  bottom: 0;
  right: 0;
  top: initial;
  left: initial;
}

#main_top .swiper-container {
  padding-bottom: 20px;
}

#main_sub .swiper-container {
  padding-bottom: 10px;
}

#main_top .swiper-slide .swiper-slide-active {
  height: 53.333vw;
}

#main_top .swiper-slide img {
  width: 100%;
}
#main_top #main_progress,
#main_sub #sub_progress {
  background-color: #ebeef1 !important;
}

.main_mining_guide {
  position: relative;
}

.main_mining_guide img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.main_mining_guide {
  height: 289px;
}

.main_mining_guide .title h2 {
  font-size: 18px;
}
.main_mining_guide .title p,
.main_mining_guide .mining_desc {
  font-size: 12px;
  color: #9ea3ab;
  font-weight: bolder;
  margin-bottom: 29px;
}

.main_mining_guide .mining_desc {
  width: 60%;
}
.guide_list {
  display: flex;
  flex-wrap: wrap;
}

.guide_list .num_data {
  margin-right: 16px;
  margin-bottom: 22px;
}
.guide_list .num_data:nth-child(5),
.guide_list .num_data:nth-child(7) {
  margin-right: 0;
}
.guide_list .num_data .cnt {
  font-size: 16px;
  color: #ff7100;
}

.guide_list .num_data .name {
  font-size: 13px;
  color: #252d3a;
}

.guide_list .num_data .text {
  font-size: 11px;
  color: #9ea3ab;
}
</style>
